import {Component, EventEmitter, Input, Output} from '@angular/core';
import { MaterialModule } from 'src/app/app.materials';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SearchPipe } from 'src/app/shared/services/search.pipe';

@Component({
  selector: 'app-filter-select',
  templateUrl: './filter-select.component.html',
  styleUrls: ['./filter-select.component.scss'],
  standalone: true,
  imports: [MaterialModule, FormsModule, CommonModule, SearchPipe]
})
export class FilterSelectComponent {

  @Input() model: any;
  @Input() label: string;
  @Input() labelPrefix = 'All ';
  @Input() list: any[] = [];
  @Input() isRequired = false;
  @Input() isMultiple = false;
  @Input() isDisabled = false;
  @Input() isFullWidth = false;
  @Input() needAllOption = true;
  @Input() isInTableHeader = false;
  @Output() modelChanged: EventEmitter<any>;
  searchText = '';

  constructor() {
    this.modelChanged = new EventEmitter<any>();
  }

  onModelChange() {
    this.modelChanged.emit(this.model);
  }
}
